export default __webpack_public_path__ + "static/protectnetwork-265b5daf306adc0eb8c382a90ad5ab77.png";